
<template>
  <div class="tab-bar" ref="tabBox">
    <div class="tab" v-for="(tab) in tabList" :key="tab.id" ref="tabDom" @click="clickTab(tab)">{{tab.name}}</div>
    <div class="active-bar" :style="activeBarStyle"></div>
  </div>
</template>

<script>
const EleResize = (() => {
  var EleResize = {
    _handleResize: function(e) {
      var ele = e.target || e.srcElement;
      var trigger = ele.__resizeTrigger__;
      if (trigger) {
        var handlers = trigger.__z_resizeListeners;
        if (handlers) {
          var size = handlers.length;
          for (var i = 0; i < size; i++) {
            var h = handlers[i];
            var handler = h.handler;
            var context = h.context;
            handler.apply(context, [e]);
          }
        }
      }
    },
    _removeHandler: function(ele, handler, context) {
      var handlers = ele.__z_resizeListeners;
      if (handlers) {
        var size = handlers.length;
        for (var i = 0; i < size; i++) {
          var h = handlers[i];
          if (h.handler === handler && h.context === context) {
            handlers.splice(i, 1);
            return;
          }
        }
      }
    },
    _createResizeTrigger: function(ele) {
      var obj = document.createElement("object");
      obj.setAttribute(
        "style",
        "display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden;opacity: 0; pointer-events: none; z-index: -1;"
      );
      obj.onload = EleResize._handleObjectLoad;
      obj.type = "text/html";
      ele.appendChild(obj);
      obj.data = "about:blank";
      return obj;
    },
    _handleObjectLoad: function(evt) {
      this.contentDocument.defaultView.__resizeTrigger__ = this.__resizeElement__;
      this.contentDocument.defaultView.addEventListener(
        "resize",
        EleResize._handleResize
      );
    }
  };
  if (document.attachEvent) {
    //ie9-10
    EleResize.on = function(ele, handler, context) {
      var handlers = ele.__z_resizeListeners;
      if (!handlers) {
        handlers = [];
        ele.__z_resizeListeners = handlers;
        ele.__resizeTrigger__ = ele;
        ele.attachEvent("onresize", EleResize._handleResize);
      }
      handlers.push({
        handler: handler,
        context: context
      });
    };
    EleResize.off = function(ele, handler, context) {
      var handlers = ele.__z_resizeListeners;
      if (handlers) {
        EleResize._removeHandler(ele, handler, context);
        if (handlers.length === 0) {
          ele.detachEvent("onresize", EleResize._handleResize);
          delete ele.__z_resizeListeners;
        }
      }
    };
  } else {
    EleResize.on = function(ele, handler, context) {
      var handlers = ele.__z_resizeListeners;
      if (!handlers) {
        handlers = [];
        ele.__z_resizeListeners = handlers;

        if (getComputedStyle(ele, null).position === "static") {
          ele.style.position = "relative";
        }
        var obj = EleResize._createResizeTrigger(ele);
        ele.__resizeTrigger__ = obj;
        obj.__resizeElement__ = ele;
      }
      handlers.push({
        handler: handler,
        context: context
      });
    };
    EleResize.off = function(ele, handler, context) {
      var handlers = ele.__z_resizeListeners;
      if (handlers) {
        EleResize._removeHandler(ele, handler, context);
        if (handlers.length === 0) {
          var trigger = ele.__resizeTrigger__;
          if (trigger) {
            trigger.contentDocument.defaultView.removeEventListener(
              "resize",
              EleResize._handleResize
            );
            ele.removeChild(trigger);
            delete ele.__resizeTrigger__;
          }
          delete ele.__z_resizeListeners;
        }
      }
    };
  }
  return EleResize;
})();

export default {
  props: {
    activeID: {},
    tabList: {}
  },
  computed: {
    activeBarWidth() {
      if (!this.$refs.tabDom) {
        return (1 / this.tabList.length) * 100 + "%";
      }
      return this.$refs.tabDom[this.index].clientWidth + "px";
    },
    tabMap() {
      let map = {};
      for (let index in this.tabList) {
        let node = this.tabList[index];
        map[node.id] = +index;
      }
      return map;
    }
  },
  watch: {
    index() {
      this.$emit("update:activeID", this.tabList[this.index].id);
    },
    activeID() {
      this.index = this.tabMap[this.activeID] || 0;
      this.resetActiveBar();
    },
    tabList() {
      this.$nextTick(() => {
        this.resetActiveBar();
      });
    }
  },
  data() {
    return {
      index: 0,
      activeBarStyle: {
        width: (1 / this.tabList.length) * 100 + "%",
        left: 0
      }
    };
  },
  methods: {
    initPlayer() {},
    resetActiveBar() {
      if (!this.$refs.tabDom || !this.$refs.tabDom[this.index]) {
        return;
      }
      this.activeBarStyle.width = this.$refs.tabDom[this.index].clientWidth + "px";

      let left = 0;
      for (let index in this.$refs.tabDom) {
        if (+index >= +this.index) {
          break;
        }
        left += this.$refs.tabDom[index].clientWidth;
      }
      this.activeBarStyle.left = left + "px";
    },
    clickTab(tab) {
      let index = this.tabList.indexOf(tab);
      if (index < 0) {
        index = 0;
      }
      this.index = index;
      this.$refs.tabBox.classList.add("move");
      this.resetActiveBar();
      setTimeout(() => {
        this.$refs.tabBox.classList.remove("move");
      }, 300);
    }
  },
  created() {
    this.index = this.tabMap[this.activeID] || 0;
    /*for(let index in this.tabList){
        let node = this.tabList[index];
        if(node.id == this.activeID){
          this.index = index;
        }
      }*/
  },
  mounted() {
    this.resetActiveBar();
    EleResize.on(this.$refs.tabBox, () => {
      this.resetActiveBar();
    });
  }
};
</script>

<style lang="scss" scoped>
.move {
  .active-bar {
    transition: all 0.3s ease-in-out;
  }
}
.tab-bar {
  position: relative;
  padding-bottom: 0.18rem;
  margin-bottom: 0.1rem;
  line-height: 0.26rem;
  display: flex;
  .tab {
    // flex:1;
    flex-grow: 1;
    height: 0.3rem;
    color: #232324;
    font-size: 0.22rem;
    .lang-jp & {
      font-size: .2rem;
    }
    // display: inline-block;
    text-align: center;
    padding: 0 0.1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .lang-en &:nth-child(2) {
      font-size: 0.19rem;
    }
  }
  &:after {
    content: "";
    height: 0.02rem;
    min-height: 1px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(253, 241, 179, 0.6);
  }
  .active-bar {
    position: absolute;
    left: 0;
    bottom: 0;
    // width: 50%;
    height: 0.02rem;
    min-height: 1px;
    background: #f9d004;
    z-index: 1;
    &:before,
    &:after {
      content: "";
      position: absolute;
      bottom: 0.02rem;
      left: 50%;
      margin-left: -0.1rem;
      border-bottom: 0.11rem solid rgba(253, 241, 179, 0.6);
      border-left: 0.1rem solid transparent;
      border-right: 0.1rem solid transparent;
    }
    &:after {
      margin-left: -0.08rem;
      border-bottom: 0.08rem solid #f9d004;
      border-left: 0.08rem solid transparent;
      border-right: 0.08rem solid transparent;
    }
  }
}
</style>
